import type { SVGProps } from 'react'
const LineEnterprise = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		fill="none"
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M17.5 11V3h-11v5H3v13h18V11zm-11 8.5h-2v-10h2zm9.5 0H8v-15h8zm3.5 0h-2v-7h2zM11 6H9.5v2.5H11zm2 0h1.5v2.5H13zm-2 4H9.5v2.5H11zm2 0h1.5v2.5H13zm-2 4H9.5v2.5H11zm2 0h1.5v2.5H13z"
			clipRule="evenodd"
		/>
	</svg>
)
export { LineEnterprise }
